

// import React from "react";
// import styled from "styled-components";
// import { useTheme } from "../App"; // 🔥 Import the global theme hook

// /* ================= FOOTER ================= */
// const FooterWrapper = styled.footer`
//   margin-top: 48px;
//   background: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%)'};
//   border-top: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(226, 232, 240, 0.9)'};
//   color: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#374151'};
//   transition: background 0.3s ease, border-color 0.3s ease, color 0.3s ease;
// `;

// const FooterInner = styled.div`
//   max-width: 1200px;
//   margin: 0 auto;
//   padding: 28px 20px 18px;
// `;

// const TopRow = styled.div`
//   display: grid;
//   grid-template-columns: 1.2fr 1fr auto;
//   gap: 24px;
//   align-items: start;

//   @media (max-width: 900px) {
//     grid-template-columns: 1fr 1fr;
//   }

//   @media (max-width: 640px) {
//     grid-template-columns: 1fr;
//     gap: 18px;
//   }
// `;

// const FooterSection = styled.div`
//   text-align: left;

//   @media (max-width: 640px) {
//     text-align: center;
//   }
// `;

// const Brand = styled.h3`
//   margin: 0;
//   font-size: 1.15rem;
//   font-weight: 800;
//   color: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
//   letter-spacing: -0.03em;
//   transition: color 0.3s ease;

//   span {
//     color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#2563eb'};
//   }
// `;

// const BrandText = styled.p`
//   margin: 10px 0 0;
//   font-size: 0.94rem;
//   color: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
//   line-height: 1.7;
//   max-width: 320px;
//   transition: color 0.3s ease;

//   @media (max-width: 640px) {
//     max-width: 100%;
//   }
// `;

// const BottomRow = styled.div`
//   margin-top: 22px;
//   padding-top: 16px;
//   border-top: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(226, 232, 240, 0.9)'};
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 12px;
//   flex-wrap: wrap;
//   transition: border-color 0.3s ease;

//   @media (max-width: 640px) {
//     flex-direction: column-reverse; /* Keeps the @2026 at the very bottom on mobile */
//     justify-content: center;
//     text-align: center;
//   }
// `;

// const Copyright = styled.p`
//   margin: 0;
//   font-size: 0.88rem;
//   color: ${({ $isDarkMode }) => $isDarkMode ? '#64748b' : '#64748b'};
// `;

// const BottomNoteWrapper = styled.div`
//   text-align: right;

//   @media (max-width: 640px) {
//     text-align: center;
//     margin-bottom: 12px;
//   }
// `;

// const NoteSub = styled.div`
//   font-style: italic;
//   font-size: 0.85rem;
//   color: ${({ $isDarkMode }) => $isDarkMode ? '#64748b' : '#64748b'};
//   margin-top: 2px;
// `;

// /* ================= COMPONENT ================= */
// const Footer = () => {
//   // 🔥 GET GLOBAL THEME 🔥
//   const { isDarkMode } = useTheme();

//   return (
//     // 🔥 PASS THEME STATE TO COMPONENTS 🔥
//     <FooterWrapper $isDarkMode={isDarkMode}>
//       <FooterInner>
//         <TopRow>
//           <FooterSection>
//             <Copyright $isDarkMode={isDarkMode}>
//               @2026 SPIRITMAN Online
//             </Copyright>
//           </FooterSection>
//           <FooterSection>
//             <Brand $isDarkMode={isDarkMode}>
//               <span>SPIRITMAN</span>Online
//             </Brand>
//             <BrandText $isDarkMode={isDarkMode}>
//               Spiritual Development and Discipleship Tool
//             </BrandText>
//           </FooterSection>
//         </TopRow>

//         <BottomRow $isDarkMode={isDarkMode}>          
//           <BottomNoteWrapper>
//             <NoteSub $isDarkMode={isDarkMode}>
//               Building and Raising the next generation of leaders
//             </NoteSub>
//           </BottomNoteWrapper>
//         </BottomRow>
//       </FooterInner>
//     </FooterWrapper>
//   );
// };

// export default Footer;




import React from "react";
import styled from "styled-components";
import { useTheme } from "../App";

const FooterWrapper = styled.footer`
  margin-top: 48px;
  background: ${({ $isDarkMode }) => $isDarkMode ? '#696969' : '#0f172a'};
  color: #e2e8f0;
  border-top: 1px solid rgba(255,255,255,0.1);
`;

const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px 40px;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 40px;

  @media (max-width: 992px) {
    grid-template-columns: 2fr 1fr;
  }
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 35px;
  }
`;

const BrandSection = styled.div``;

const Brand = styled.h3`
  margin: 0 0 16px 0;
  font-size: 1.65rem;
  font-weight: 800;
  color: white;
  letter-spacing: -0.04em;
`;

const BrandText = styled.p`
  margin: 0;
  font-size: 1.02rem;
  line-height: 1.65;
  color: #cbd5e1;
  max-width: 340px;
`;

const FooterColumn = styled.div``;

const ColumnTitle = styled.h4`
  margin: 0 0 20px 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FooterLink = styled.li`
  margin-bottom: 12px;

  a {
    color: #cbd5e1;
    text-decoration: none;
    font-size: 1rem;
    transition: color 0.3s ease;

    &:hover {
      color: #60a5fa;
    }
  }
`;

const CopyrightRow = styled.div`
  margin-top: 60px;
  padding-top: 20px;
  border-top: 1px solid rgba(255,255,255,0.1);
  display: flex;
  justify-content: center;
  color: #94a3b8;
  font-size: 0.92rem;
  text-align: center;
`;

/* ================= COMPONENT ================= */
const Footer = () => {
  const { isDarkMode } = useTheme();

  return (
    <FooterWrapper $isDarkMode={isDarkMode}>
      <FooterInner>
        <FooterGrid>
          {/* Brand Column */}
          <BrandSection>
            <Brand>ChurchOnline</Brand>
            <BrandText>
              Empowering believers through technology. Experience live services, 
              teachings, and community from anywhere.
            </BrandText>
          </BrandSection>

          {/* Platform Column */}
          <FooterColumn>
            <ColumnTitle>Platform</ColumnTitle>
            <FooterLinks>
              <FooterLink><a href="/">Home</a></FooterLink>
              <FooterLink><a href="/live">Live Stream</a></FooterLink>
              <FooterLink><a href="/messages">Messages</a></FooterLink>
              <FooterLink><a href="/foundation">Foundation</a></FooterLink>
            </FooterLinks>
          </FooterColumn>

          {/* Resources Column */}
          <FooterColumn>
            <ColumnTitle>Resources</ColumnTitle>
            <FooterLinks>
              <FooterLink><a href="/help">Help Center</a></FooterLink>
              <FooterLink><a href="/prayer">Prayer Request</a></FooterLink>
              <FooterLink><a href="/give">Give Online</a></FooterLink>
              <FooterLink><a href="/testimony">Testimony</a></FooterLink>
            </FooterLinks>
          </FooterColumn>

          {/* Company Column */}
          <FooterColumn>
            <ColumnTitle>Company</ColumnTitle>
            <FooterLinks>
              <FooterLink><a href="/about">About Us</a></FooterLink>
              <FooterLink><a href="/contact">Contact</a></FooterLink>
              <FooterLink><a href="/admin">Admin</a></FooterLink>
            </FooterLinks>
          </FooterColumn>
        </FooterGrid>

        <CopyrightRow>
          © 2026 Church Online. All rights reserved.
        </CopyrightRow>
      </FooterInner>
    </FooterWrapper>
  );
};

export default Footer;